<template>
    <div>
        <Sms />
    </div>
</template>

<script>
import Sms from "./smsView.vue";
export default {
    components: {
        Sms,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
